import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Checkbox from 'shared/components/checkbox/Checkbox';
import Button from 'shared/components/button/Button';
import BootstrapSpinner from 'shared/components/bootstrap-spinner/BootstrapSpinner';
import styles from './TermsAcceptanceModal.module.css';
import { normalizeTermsContent } from './termsAcceptance.constants';

function TermsAcceptanceModal({
  errorMessage = '',
  isLoading = false,
  isLoadingContent = false,
  onConfirm,
  show,
  termsContent,
}) {
  const [acknowledged, setAcknowledged] = useState(false);
  const content = normalizeTermsContent(termsContent);
  const loadErrorMessage = errorMessage || 'Unable to load terms.';

  useEffect(() => {
    if (show) {
      setAcknowledged(false);
    }
  }, [show]);

  return (
    <Modal show={show} centered size="lg" backdrop="static" keyboard={false}>
      <Modal.Header className={styles.header}>
        {isLoadingContent ? 'Terms' : content?.title || 'Terms'}
      </Modal.Header>
      <Modal.Body className={styles.body}>
        {isLoadingContent ? (
          <div className={styles.loadingContent}>
            <BootstrapSpinner size="48px" />
          </div>
        ) : content ? (
          <>
            {content.description && (
              <p className={styles.intro}>{content.description}</p>
            )}
            <ul className={styles.list}>
              {content.terms.map((term) => (
                <li key={term.heading}>
                  <strong>{term.heading}: </strong>
                  {term.body}
                </li>
              ))}
            </ul>
            <div className={styles.checkboxRow}>
              <Checkbox
                label={content.acknowledgementLabel}
                active={acknowledged}
                onCheck={setAcknowledged}
                disabled={isLoading}
              />
            </div>
            {errorMessage && <p className={styles.error}>{errorMessage}</p>}
          </>
        ) : (
          <p className={styles.error}>{loadErrorMessage}</p>
        )}
      </Modal.Body>
      {!isLoadingContent && content && (
        <Modal.Footer className={styles.footer}>
          <Button
            text="Confirm"
            onClick={onConfirm}
            disabled={!acknowledged || isLoading}
            isLoading={isLoading}
          />
        </Modal.Footer>
      )}
    </Modal>
  );
}

export default TermsAcceptanceModal;
